
import PaginatedReviewResourceView from '@/mixins/PaginatedReviewResourceView';
import { mapState, mapGetters, mapMutations } from 'vuex';
import ReviewContentType from '@/enums/ReviewContentType';
export default {
  i18nComponentKey: 'WidgetCategoryReviewsList.WidgetCategoryReviewsListPc',
  name: 'WidgetCategoryReviewsListPc',
  mixins: [PaginatedReviewResourceView],
  computed: {
    ...mapState('widget', ['widget']),
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapState('window', ['windowService']),
    ...mapGetters('widget', [
      'appHeaderShowable',
      'headerSectionShowable',
      'showFilterSection'
    ]),
    ...mapGetters('reviewSettings', ['isAuthorDisplayTypeUserGrade']),
    ...mapGetters('review', ['isManagerReview', 'showScoreSection']),
    defaultResourceParams() {
      return {
        fields: [
          'reviews.customer_properties',
          'reviews.evaluation_properties',
          this.reviewSettings.use_comments &&
          this.reviewSettings.always_show_comments
            ? 'reviews.comments'
            : '',
          this.isAuthorDisplayTypeUserGrade ? 'reviews.brand_user_grade' : ''
        ]
          .filter(v => v)
          .join(',')
      };
    },
    contentsStyle() {
      return {
        '--min-height': this.showFilterSection ? '204px' : 'auto'
      };
    }
  },
  created() {
    this.SET_EDIT_OR_DELETE_CALLBACK(() => this.searchResource());
  },
  beforeDestroy() {
    this.SET_EDIT_OR_DELETE_CALLBACK(null);
  },
  methods: {
    ...mapMutations('review', ['SET_EDIT_OR_DELETE_CALLBACK']),
    submit(params) {
      this.searchResource(params);
    },
    shouldDisplayMediaSection(review) {
      return (
        review.content_type !== ReviewContentType.RESTRICTED &&
        (review.images.length > 0 || review.videos.length > 0)
      );
    }
  }
};
